import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import CGMStatusCardTemplate from "./CGMStatusCardTemplate";
import Button from "src/components/app/Button";

import CGMExpiredStatus from "src/assets/images/cgm/status/cgm-expired-status.png";
import useCgmHook from "src/hooks/useCgm.hook";

interface CGMDisconnectedStatusCardProps {
  color: string;
  label: string;
  bgColor?: string;
}

const CGMDisconnectedStatusCard: React.FC<CGMDisconnectedStatusCardProps> = ({
  color,
  label,
  bgColor,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const supportProgramKey = params["support-program-key"] ?? "";
  const { sensorInfo } = useCgmHook();

  return (
    <CGMStatusCardTemplate
      image={CGMExpiredStatus}
      color={color}
      bgColor={bgColor}
      label={label}
      sensorStartDate={sensorInfo.startDate}
      sensorEndDate={sensorInfo.endDate}
      description={
        <div>
          <p className="text-xs mb-4">
            The app can’t detect your transmitter. Reconnect it to continue
            monitoring.
          </p>
          <Button
            variant="contained"
            color="primary"
            rounded="full"
            fullWidth
            onClick={() =>
              navigate(`/app/${supportProgramKey}/cgm-connection?restart=true`)
            }
          >
            Reconnect Transmitter
          </Button>
        </div>
      }
      bottomContent={
        <p className="text-sm text-gray-500 text-center">
          Take a look at your{" "}
          <Link
            to={`/app/${supportProgramKey}/insights-screen?tab=vitals&sub-tab=glucose`}
            className="text-[var(--app-primary)] font-semibold underline"
          >
            CGM Insights
          </Link>
        </p>
      }
    />
  );
};

export default CGMDisconnectedStatusCard;
